var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,15v1.59l-1.56,1.56-3.44,1.38v-7.52h3v-2h-3v-2h.15l.87-.5,1.16-2v-1l-1.16-2-.87-.5h-2.31l-.87,.5-1.16,2v1l1.16,2,.87,.5h.15v2h-3v2h3v7.52l-3.44-1.38-1.56-1.56v-1.59h-2v2l.29,.71,2,2,.34,.22,5,2h.74l5-2,.34-.22,2-2,.29-.71v-2h-2ZM10.85,5l.58-1h1.15l.58,1-.58,1h-1.15l-.58-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnchor);
export default __webpack_public_path__ + "static/1768397567/media/icon-anchor.7eef8c2229560f1b0244d05e967131ae.svg";
export { ForwardRef as ReactComponent };